"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Value = function Value(_ref) {
  var className = _ref.className,
      children = _ref.children,
      highlight = _ref.highlight,
      toggled = _ref.toggled,
      otherProps = _objectWithoutProperties(_ref, ["className", "children", "highlight", "toggled"]);

  return /*#__PURE__*/_react.default.createElement(StyledValue, _extends({}, otherProps, {
    className: className
  }), children, highlight ? /*#__PURE__*/_react.default.createElement("span", {
    onClick: function onClick() {
      return toggled();
    }
  }, highlight) : null);
};

var StyledValue = _styledComponents.default.td.withConfig({
  displayName: "StyledValue"
})(["color:", ";display:flex;align-items:center;width:100%;font-weight:500;justify-content:space-between;& span{background-color:", ";color:white;text-transform:uppercase;height:3rem;padding:0 1.5rem;display:flex;justify-content:center;align-items:center;border-radius:0.3rem;font-size:1.2rem;}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.typo.highlight;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.brand.secondary;
});

Value.defaultProps = {
  otherProps: {}
};
Value.propTypes = {
  /** Beeing able to use it in Styled Components */
  className: _propTypes.string,

  /** Adds extra props to the element */
  otherProps: _propTypes.object,

  /** triggers when highlight is clicked */
  toggled: _propTypes.func,

  /** clickable highlight */
  highlight: _propTypes.string,

  /** Value text */
  children: _propTypes.node.isRequired
};
var _default = Value;
exports.default = _default;